/**
 * 本地存储工具类
 */
export class Storage {
  /**
   * 获取存储的值
   */
  static get(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      console.warn('[MetricTracker] localStorage.getItem failed:', error);
      return null;
    }
  }

  /**
   * 设置存储的值
   */
  static set(key: string, value: string): boolean {
    try {
      localStorage.setItem(key, value);
      return true;
    } catch (error) {
      console.warn('[MetricTracker] localStorage.setItem failed:', error);
      return false;
    }
  }

  /**
   * 删除存储的值
   */
  static remove(key: string): boolean {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (error) {
      console.warn('[MetricTracker] localStorage.removeItem failed:', error);
      return false;
    }
  }

  /**
   * 检查 localStorage 是否可用
   */
  static isAvailable(): boolean {
    try {
      const testKey = '__metric_storage_test__';
      localStorage.setItem(testKey, '1');
      localStorage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  }
}
